import React, { useContext } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import backgroundImage from '../images/homepage/hero-background.png'
import AppContext from '../context/app'
import airLogoOutlineWhiteVertical from '../images/svgs/air-logo-outline-white-vertical.svg'

export default function Hero() {
    const { screenWidth, clientWidth } = useContext(AppContext)

    class Video {
        constructor(id, height, width) {
            this.id = id
            this.height = height
            this.width = width
            this.aspectRatio = height / width
        }
    }

    const mobile = new Video('949622263', 1080, 830)
    const desktop = new Video('949172146', 560, 1440)
    const video = screenWidth < 768 ? mobile : desktop

    return (
        <div className='position-relative'>
            <div className='position-relative' style={{ paddingTop: `${(video.aspectRatio * clientWidth).toFixed(0)}px` }}>
                {/* VIMEO VIDEO EMBED */}
                <iframe
                    src={`https://player.vimeo.com/video/${video.id}?muted=1&autoplay=1&loop=1&controls=0&app_id=58479`}
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                    className='position-absolute w-100 h-100 start-0 top-0'
                    style={{ zIndex: -2 }}
                    title=""
                />

                {/* "BACKDROP" */}
                <div
                    className='position-absolute w-100 h-100 start-0 top-0'
                    style={{ background: `rgba(0,0,0,.5)`, zIndex: -1 }}
                />

                {/* AIR LOGO ON THE RIGHT */}
                <img
                    src={airLogoOutlineWhiteVertical}
                    alt=''
                    className='position-absolute end-0 top-50 translate-middle-y mh-100 d-none d-md-block'
                />
            </div>

            <Container fluid className='position-absolute start-0 top-50 translate-middle-y'>
                <Container>
                    <Row className='align-items-center'>
                        <Col xl={4} md={6}>
                            <h1 className='changeling-neo text-white mb-4' style={{
                                fontSize: screenWidth < 1024 ? 48 : 72,
                                lineHeight: `${screenWidth < 1024 ? 32 : 48}px`
                            }}>
                                <span style={{
                                    WebkitTextStrokeWidth: 1,
                                    WebkitTextFillColor: "rgba(0,0,0,0)"
                                }}>
                                    BREATHE
                                    <br />
                                    IN FRESH
                                </span>
                                <br />
                                <span>CREATIVITY</span>
                            </h1>
                            <p className='fw-medium text-white mb-0'
                                style={{ fontSize: screenWidth < 1024 ? 14 : 16, }}
                            >
                                AIR provides legendary virtual instruments, effects, expansions, sound packs and software subscriptions that bring music production to the next level.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
